export default "__VITE_ASSET__557c8595__"